import axios from "axios"
import store from "../../erp_store/erp_store"
import router from "../../erp_router"

export default {
  setHeader() {
    const authData = store.getters["auth/authData"]
    const headers = {
      "access-token": authData.accessToken,
      uid: authData.uid,
      client: authData.client,
    }
    return headers
  },
  isAdmin() {
    const authData = store.getters["auth/authData"]
    const headers = {
      "access-token": authData.accessToken,
      uid: authData.uid,
      client: authData.client,
    }
    axios
      .get("/api/v1/auth/validate_token", { headers })
      .then((res) => {
        if (!res.data.data.admin_flag) {
          store.dispatch("setFlash", {
            text: "不正なアクセスです",
            type: "alert",
          })
          router.push("/erp")
        }
      })
      .catch((err) => {
        store.dispatch("setFlash", {
          text: "ログインして下さい",
          type: "alert",
        })
        router.push("/erp/login")
      })
  },
  authenticateUser() {
    if (!store.getters["auth/isAuthenticated"]) {
      store.dispatch("setFlash", {
        text: "ログインして下さい",
        type: "alert",
      })
      router.push("/erp/login")
    }
  },
  unauthenticateUser() {
    if (store.getters["auth/isAuthenticated"]) {
      store.dispatch("setFlash", {
        text: "既にログインしています",
        type: "alert",
      })
      router.push("/erp")
    }
  },
}
